/*
创建者 魏强(2018.3.5)
自营商城首页
*/
<template>
  <div class="self-support-page">
    <!-- 搜索 -->
    <zyheader></zyheader>

    <div
      class="warpper"
      v-if="show"
    >
      <div class="mod-focus">
        <div class="mod-focus-menu">
          <h3>全部商品分类</h3>
          <div class="nav-class">
            <ul>
              <li
                v-for="(row,$index) in storeNavigation"
                v-if="row.storeCatPid=='0'"
              >
                <router-link :to="{path:'/shop',query:{tab:2,store_id:row.storeId,pid:row.storeCatPid,acid:row.storeCatPid}}">
                  {{row.storeCatName}} <b class="right"><i class="right-arrow1"></i><i class="right-arrow2"></i></b>
                </router-link>
              </li>
            </ul>
          </div>
          <div class="nav-more">
            <router-link :to="{path:'/shop',query:{tab:2,store_id:1}}">
              更多分类>>
            </router-link>
          </div>
        </div>
        <!-- banner -->
        <div
          class="mod-focus-swipe"
          id="focus-swipe"
        >
          <banner
            :data="zyshgBannerAdv.advList"
            :size="zyshgBannerAdv.adColumn"
          ></banner>
        </div>
        <!-- 定位广告位标签  -->
        <div class="mod-focus-sidebar">
          <router-link
            :to="zyshgdbycAdv.url"
            target="_blank"
          >
            <img
              :src="zyshgdbycAdv.atturl"
              alt="暂无图片"
              width="240px"
              height="418px;"
            >
          </router-link>
        </div>

        <!--<router-link class="allgoods" :to="{path:'/shop',query:{tab:1,store_id:1}}" target="_blank">
          全部商品
        </router-link>-->
      </div>

      <!-- 盾盾精选 -->
      <gd-selected :data="{b:ddjxnshang,s:ddjxnxia}"></gd-selected>

      <!-- 精品直降 -->
      <boutique-discount
        :data="jpzjdata"
      ></boutique-discount>

      <!-- 模块1 -->
      <!-- <gd-selling-item :data="m1" :cat="zyshgTagData" :other="{num:1}"></gd-selling-item> -->

      <!-- 模块2 -->
      <!-- <gd-selling-item :data="m2" :cat="zyshgTagData" :other="{num:2}"></gd-selling-item> -->

      <!-- 模块3 -->
      <!-- <gd-selling-item :data="m3" :cat="zyshgTagData" :other="{num:3}"></gd-selling-item> -->

      <!-- 模块4 -->
      <!-- <gd-selling-item :data="m4" :cat="zyshgTagData" :other="{num:4}"></gd-selling-item> -->

      <!-- 还没逛够 -->
      <not-enough :data="hmggData"></not-enough>

    </div>

  </div>
</template>
<script>
import zyheader from "./header";
import banner from "./banner";
import gdSelected from "./gd-selected";
import boutiqueDiscount from "./boutique-discount";
import notEnough from "./not-enough";
import gdSellingItem from "./gd-selling-item";
import { zyIndex } from "api/self-support";
import { continueShopping } from "api/home";
import { parseAdvList } from "utils/tool";
export default {
  components: {
    zyheader,
    banner,
    gdSelected,
    boutiqueDiscount,
    gdSellingItem,
    notEnough,
  },
  data() {
    return {
      show: false,
      list: this.data,
      pageNo: 2,
      pageSize: 20,
      hasMore: true,
      loading: false,
      hasBoundScroll: false,
      hmggData: [],
      jpzjdata: [],
      ddjxnxia: []
    };
  },
  created() {
    this.getZyIndex();
  },
  mounted() {
    this.bindScroll();
  },
  destroyed() {
    $(window).unbind("scroll");
  },
  activated() {
    this.bindScroll();
  },
  deactivated() {
    $(window).unbind("scroll");
    this.hasBoundScroll = false;
  },
  methods: {
    getZyIndex() {
      zyIndex().then((json) => {
        if (json.resCode == 1) {
          this.show = true;
          const data = json.data;
          //店铺导航列表
          this.storeNavigation = parseAdvList(data.storeCategoryVOList);

          //zyshgTagData
          // this.zyshgTagData = data.indexPageCategoryDTOList.map((item) => {
          //   let _childrean = parseAdvList(item.childrean);
          //   item.childrean = _childrean;
          //   return item;
          // });
          //banner
          this.zyshgBannerAdv = data.headLivingHallAdvertisementDTO;
          //banner 右侧广告
          this.zyshgdbycAdv =
            parseAdvList(data.selfHotSellAdvertisementDTO.advList)[0] || {};
          //盾盾精选 上
          this.ddjxnshang = parseAdvList(
            data.goodSelectRightUpAdvertisementDTO ? data.goodSelectRightUpAdvertisementDTO.advList : []
          );
          //盾盾精选 下
          this.ddjxnxia = parseAdvList(
            data.goodSelectDownAdvertisementDTO ? data.goodSelectDownAdvertisementDTO.advList : []
          ); //ddjxnxia
          //精品直降
          this.jpzjdata = parseAdvList(
            data.highQualityGoodsStraightDownAdvertisementDTO.advList || []
          );
          console.log(this.jpzjdata, 'this.jpzjdata---------');

          //第一个模块
          // this.m1 = {
            // adv: parseAdvList(data.lifeBeautifulAdvertisementDTO ? data.lifeBeautifulAdvertisementDTO.advList : []), //左侧广告
            // goods1: parseAdvList(data.eyeCreamAdvertisementDTO ? data.eyeCreamAdvertisementDTO.advList : []), //中间商品（第一个大的）
            // goods2: parseAdvList(
            //   data.lifeBeautifulCenterDownAdvertisementDTO ? data.lifeBeautifulCenterDownAdvertisementDTO.advList : []
            // ), //中间商品（后面几个小的）
            // banners1: parseAdvList(
            //   data.lifeBeautifulRightUpAdvertisementDTO ? data.lifeBeautifulRightUpAdvertisementDTO.advList : []
            // ), //右侧上轮播
            // banners2: parseAdvList(
            //   data.clearSourceAdvertisementDTO ? data.clearSourceAdvertisementDTO.advList : []
            // ), //右侧下轮播
          // };

          //第二个模块
          // this.m2 = {
            // adv: parseAdvList(data.ddsxzcAdv ? data.ddsxzcAdv.advList : []), //左侧广告
            // goods1: parseAdvList(data.ddsxzhhAdv ? data.ddsxzhhAdv.advList : []), //中间商品（第一个大的）
            // goods2: parseAdvList(data.ddsxzhAdv ? data.ddsxzhAdv.advList : []), //中间商品（后面几个小的）
            // banners1: parseAdvList(data.ddsxycdAdv ? data.ddsxycdAdv.advList : []), //右侧上轮播
            // banners2: parseAdvList(data.ddsxycxAdv ? data.ddsxycxAdv.advList : []), //右侧下轮播
          // };

          //第三个模块
          // this.m3 = {
            // adv: parseAdvList(data.smallTimeAdvertisementDTO ? data.smallTimeAdvertisementDTO.advList : []), //左侧广告
            // goods1: parseAdvList(
            //   data.smallTimeCenterLeftAdvertisementDTO ? data.smallTimeCenterLeftAdvertisementDTO.advList : []
            // ), //中间商品（第一个大的）
            // goods2: parseAdvList(data.alcoholAdvertisementDTO ? data.alcoholAdvertisementDTO.advList : []), //中间商品（后面几个小的）
            // banners1: parseAdvList(
            //   data.smallTimeRightUpAdvertisementDTO ? data.smallTimeRightUpAdvertisementDTO.advList : []
            // ), //右侧上轮播
            // banners2: parseAdvList(
            //   data.alcoholSdcAdvertisementDTO ? data.alcoholSdcAdvertisementDTO.advList : []
            // ), //右侧下轮播
          // };

          //第四个模块
          // this.m4 = {
            // adv: parseAdvList(data.foodieAdvertisementDTO ? data.foodieAdvertisementDTO.advList : []), //左侧广告
            // goods1: parseAdvList(data.loquatTeaAdvertisementDTO ? data.loquatTeaAdvertisementDTO.advList : []), //中间商品（第一个大的）
            // goods2: parseAdvList(
            //   data.doctorMedicineAdvertisementDTO ? data.doctorMedicineAdvertisementDTO.advList : []
            // ), //中间商品（后面几个小的）
            // banners1: parseAdvList(
            //   data.walnutSesamePowderAdvertisementDTO ? data.walnutSesamePowderAdvertisementDTO.advList : []
            // ), //右侧上轮播
            // banners2: parseAdvList(
            //   data.foodieRightDownAdvertisementDTO ? data.foodieRightDownAdvertisementDTO.advList : []
            // ), //右侧下轮播
          // };

          //还没逛够
          this.hmggData = data.storeGoodsList;

          //滚动加载
          this.bindScroll();
        } else {
          this.$Message.error(json.resDesc);
        }
      });
    },
    fetchData() {
      if (this.hasMore && !this.loading) {
        this.loading = true;
        continueShopping(this.pageNo, this.pageSize, 1).then((json) => {
          this.loading = false;
          if (json.resCode == 1) {
            let data = json.data;
            this.hasMore = data.hasMore;
            if (this.hasMore) {
              this.pageNo = this.pageNo + 1;
            }
            let list = data.list || [];
            let temp = this.hmggData || [];
            this.hmggData = temp.concat(list);
          }
        });
      }
    },
    bindScroll() {
      //防止重复绑定
      if (!this.hasBoundScroll) {
        let _this = this;
        this.hasBoundScroll = true;
        $(window).scroll(function (e) {
          var scrollTop = $(this).scrollTop();
          var scrollHeight = $(document).height();
          var windowHeight = $(window).height();
          if (
            scrollTop + windowHeight + 430 >= scrollHeight &&
            _this.hasMore &&
            !_this.loading
          ) {
            _this.fetchData();
          }
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?7dc4ce28